<template>
  <div class="chart-container" ref="container">
    <canvas ref="canvas" :id="chartName" class="gaugeCanvas"></canvas>
  </div>
</template>

<script>
export default {
  props: ['chartName', 'data'],

  mounted() {
    this.$nextTick(() => {
      this.drawGauge();
      this._resizeObserver = new ResizeObserver(() => this.drawGauge());
      this._resizeObserver.observe(this.$refs.container);
    });
  },

  beforeDestroy() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  },

  methods: {
    drawGauge() {
      const container = this.$refs.container;
      const canvas = this.$refs.canvas;
      if (!container || !canvas) return;

      const w = container.clientWidth || 220;
      const h = w / 2;
      const dpr = window.devicePixelRatio || 1;

      canvas.width  = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width  = w + 'px';
      canvas.style.height = h + 'px';

      const ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);

      // Center is at the bottom-center so the arc sweeps over the top
      const cx = w / 2;
      const cy = h;
      const outerR = h * 0.88;
      const innerR = outerR * 0.65;

      // data.data contains cumulative segment endpoints, e.g. [40, 60, 100]
      // Segment i spans from endpoints[i-1] (or 0) to endpoints[i]
      const endpoints = this.data.data;
      const colors    = this.data.backgroundColor;
      const maxVal    = endpoints[endpoints.length - 1]; // 100

      // Angles: π = left side, 2π = right side (arc sweeps over the top)
      let prevEnd = 0;
      endpoints.forEach((endVal, i) => {
        const aStart = Math.PI + (prevEnd / maxVal) * Math.PI;
        const aEnd   = Math.PI + (endVal  / maxVal) * Math.PI;

        ctx.beginPath();
        ctx.arc(cx, cy, outerR, aStart, aEnd);
        ctx.arc(cx, cy, innerR, aEnd, aStart, true);
        ctx.closePath();
        ctx.fillStyle = colors[i];
        ctx.fill();

        prevEnd = endVal;
      });

      // Needle
      const value = Math.min(Math.max(this.data.value ?? 0, 0), maxVal);
      const angle  = Math.PI + (value / maxVal) * Math.PI;
      const nLen   = outerR * 0.78;

      ctx.save();
      ctx.lineWidth   = 2.5;
      ctx.strokeStyle = 'rgba(60, 60, 60, 0.85)';
      ctx.lineCap     = 'round';
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx + nLen * Math.cos(angle), cy + nLen * Math.sin(angle));
      ctx.stroke();

      // Center dot
      ctx.beginPath();
      ctx.arc(cx, cy, 5, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(60, 60, 60, 0.85)';
      ctx.fill();

      ctx.restore();
    },
  },
};
</script>

<style scoped>
.gaugeCanvas {
  display: block;
}
.chart-container {
  position: relative;
  width: 100%;
}
</style>
